import { useCallback, useMemo, FC } from 'react';
import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';
import { useFeatureUpgradeDetailsModal } from '@frontend/self-upgrade';
import { DigitalFormsFreemiumContext } from './context';
import { ActionNotPartOfFreemium, actionsNotPartOfFreemium } from './types';
import { useFormsFreemiumFeatureFlag } from './useFormsFreemiumFeatureFlag';

const FormsFreemiumMain: FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isFreemium, freemiumLocationIds } = useFormsFreemiumFeatureFlag();
  const { FeatureUpgradeDetailsModal, featureUpgradeDetailsModalControls } = useFeatureUpgradeDetailsModal({
    feature: Feature.FORMS,
  });

  const isActionBlocked = useCallback(
    (action: ActionNotPartOfFreemium, _locationId?: string) => {
      const shouldBlock = actionsNotPartOfFreemium.includes(action);
      if (isFreemium && shouldBlock) {
        //Freemium Todo: handle multi-location scenario here in future
        // if(locationId && !freemiumLocationIds.includes(locationId)){
        //   return false;
        // }
        return true;
      }
      return false;
    },
    [isFreemium]
  );

  const contextValue = useMemo(
    () => ({
      isFreemium: isFreemium,
      freemiumLocationIds,
      featureUpgradeDetailsModalControls,
      isActionBlocked,
    }),
    [isFreemium, freemiumLocationIds, featureUpgradeDetailsModalControls, isActionBlocked]
  );

  return (
    <DigitalFormsFreemiumContext.Provider value={contextValue}>
      {children}
      {FeatureUpgradeDetailsModal && (
        <FeatureUpgradeDetailsModal
          modalControls={featureUpgradeDetailsModalControls}
          onActionSuccess={() => {
            featureUpgradeDetailsModalControls.closeModal();
          }}
        />
      )}
    </DigitalFormsFreemiumContext.Provider>
  );
};

export default FormsFreemiumMain;
